export const DOCUMENT_TYPE_VEHICLE_BRAND = 'commerce.vehicleBrand';
